import {Badge, Text, Wrap, WrapItem} from "@chakra-ui/react";

export const columnsDataRole = [
  {
    accessorKey: "roleName",
    header: "Name Role",
    cell: (info) => info.getValue(),
  },
  {
    accessorKey: "description",
    header: "Description",
    cell: (info) => {
      const permissions = String(info.getValue() || "").split(" | ").filter(Boolean);

      if (permissions.length === 0) {
        return <Text color="secondaryGray.500">-</Text>;
      }

      return (
        <Wrap spacing={2} minW="220px">
          {permissions.map((permission, index) => (
            <WrapItem key={`${permission}-${index}`}>
              <Badge colorScheme="purple" variant="subtle" borderRadius="full" px={2} py={1} textTransform="none">
                {permission}
              </Badge>
            </WrapItem>
          ))}
        </Wrap>
      );
    },
  },
];
